export enum DateFilterOptions {
  LAST_WEEK = 'LAST_WEEK',
  LAST_MONTH = 'LAST_MONTH',
  LAST_QUARTER = 'LAST_QUARTER',
  CUSTOM = 'CUSTOM'
}
